query getPositionHistory($position_id: String) {
    getPositionHistory(position_id: $position_id) 
}